/*
Copyright 2023 New Vector Ltd

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/

import { Room, RoomEvent } from "matrix-js-sdk/src/matrix";
import { useState } from "react";

import { useTypedEventEmitter } from "../useEvents";

export function useRoomName(room: Room): string {
  const [, setNumUpdates] = useState(0);
  // Whenever the name changes, force an update
  useTypedEventEmitter(room, RoomEvent.Name, () => setNumUpdates((n) => n + 1));
  return room.name;
}
